<template>
    <div>
        <b-alert :show="showAlert" class="cookies-container">
            <div :style="`background-image: url(${icon});`" class="icon mr-2" />
            <i18n path="text" tag="span">
                <b-link href="https://coblue.com.br/privacidade/" target="_blank">
                    {{ $t('privacyPolicy') }}
                </b-link>
                <b-link @click="onManageCookies">{{ $t('manageYourCookies') }}</b-link>
            </i18n>
            <b-button class="ml-3" variant="primary" @click="onAccept">
                {{ $t('accept') }}
            </b-button>
        </b-alert>
        <ModalOptionalCookies
            :open.sync="showManageCookies"
            @onClose="onCloseModal"
            @thirdPartyCookies="acceptedThirdPartyCookies = $event"
        />
    </div>
</template>

<script>
import WarningIcon from '@/assets/icons/warning-cookies.svg'
import ModalOptionalCookies from './ModalOptionalCookies'

const acceptedCookiesUse = 'acceptedCookiesUse'
const useOptionalCookies = 'useOptionalCookies'

export default {
    name: 'Cookies',
    components: { ModalOptionalCookies },
    data() {
        return {
            showAlert: true,
            showManageCookies: false,
            acceptedThirdPartyCookies: true,
            icon: WarningIcon,
        }
    },
    created() {
        if (window.localStorage.getItem(acceptedCookiesUse)) this.showAlert = false
    },
    methods: {
        onAccept() {
            this.showAlert = false
            window.localStorage.setItem(acceptedCookiesUse, true)
            window.localStorage.setItem(useOptionalCookies, this.acceptedThirdPartyCookies)
        },
        onManageCookies() {
            this.showAlert = false
            this.showManageCookies = true
        },
        onCloseModal() {
            this.showAlert = true
        },
    },
    i18n: {
        messages: {
            'en-US': {
                text: 'Our platform stores cookies to collect information and enhance your experience with us. Explore our {0} and {1}.',
                privacyPolicy: 'Privacy Policy',
                manageYourCookies: 'Manage your cookies',
                accept: 'Accept',
            },
            'es-ES': {
                text: 'Nuestra plataforma almacena cookies para recopilar información y mejorar tu experiencia con nosotros. Conoce nuestra {0} y {1}.',
                privacyPolicy: 'Política de privacidad',
                manageYourCookies: 'Gestiona tus cookies',
                accept: 'Aceptar',
            },
            'pt-BR': {
                text: 'Nossa plataforma armazena cookies para coletar informações e melhorar sua experiência conosco. Conheça nossa {0} e {1}.',
                privacyPolicy: 'Política de privacidade',
                manageYourCookies: 'Gerencie seus cookies',
                accept: 'Aceitar',
            },
        },
    },
}
</script>

<style lang="scss" scoped>
.icon {
    width: 29px;
    height: 29px;
    display: inline-block;
    background-repeat: no-repeat;
}

.cookies-container {
    margin: 0;
    position: fixed;
    bottom: 0;
    left: 0;
    border: unset;
    border-radius: unset;
    span {
        font-weight: 400;
        font-size: 1.15em;
        color: #444;
        a {
            font-weight: bold;
            color: #5b5b5b;
        }
    }
}
</style>
